/**
 * Local landing areas (Norfolk + East Anglia + UK reach).
 * Used by the LocalArea page template + the footer.
 */
export const LOCAL_AREAS = [
  {
    slug: 'norwich',
    name: 'Norwich',
    region: 'Norfolk',
    headline_keyword: 'Norwich',
    h1_phrase: 'Norwich',
    primary: true,
    neighbourhoods: [
      'Norwich City Centre', 'Thorpe St Andrew', 'Sprowston', 'Hellesdon', 'Costessey',
      'Cringleford', 'Eaton', 'Drayton', 'Old Catton', 'Trowse', 'Wymondham', 'Aylsham',
      'Norwich Riverside', 'Norwich Lanes', 'Norwich Golden Triangle',
    ],
    nearby_pages: ['kings-lynn', 'great-yarmouth', 'wymondham', 'dereham', 'cromer', 'thetford'],
    blurb: 'Based in Norwich. The home base for BrightLabs.',
  },
  {
    slug: 'norfolk',
    name: 'Norfolk',
    region: 'East Anglia',
    headline_keyword: 'Norfolk',
    h1_phrase: 'Norfolk',
    primary: true,
    neighbourhoods: [
      'Norwich', "King's Lynn", 'Great Yarmouth', 'Thetford', 'Dereham', 'Wymondham',
      'Cromer', 'Sheringham', 'Diss', 'Fakenham', 'Hunstanton', 'North Walsham',
    ],
    nearby_pages: ['norwich', 'kings-lynn', 'great-yarmouth', 'east-anglia'],
    blurb: 'AI websites, automation and growth systems for every Norfolk business.',
  },
  {
    slug: 'east-anglia',
    name: 'East Anglia',
    region: 'UK East',
    headline_keyword: 'East Anglia',
    h1_phrase: 'East Anglia',
    primary: true,
    neighbourhoods: [
      'Norfolk', 'Suffolk', 'Cambridgeshire', 'Essex',
      'Norwich', 'Ipswich', 'Cambridge', 'Colchester', 'Chelmsford',
      'Bury St Edmunds', 'Lowestoft', "King's Lynn", 'Great Yarmouth',
    ],
    nearby_pages: ['norwich', 'norfolk', 'kings-lynn', 'great-yarmouth'],
    blurb: 'Serving businesses across Norfolk, Suffolk, Cambridgeshire and Essex.',
  },
  {
    slug: 'kings-lynn',
    name: "King's Lynn",
    region: 'Norfolk',
    headline_keyword: "King's Lynn",
    h1_phrase: "King's Lynn",
    primary: false,
    neighbourhoods: [
      "King's Lynn", 'South Wootton', 'North Wootton', 'Gaywood', 'West Lynn',
      'Hunstanton', 'Downham Market', 'Snettisham',
    ],
    nearby_pages: ['norwich', 'norfolk', 'east-anglia', 'great-yarmouth'],
    blurb: "AI marketing for King's Lynn businesses — trades, hospitality, care, professional services.",
  },
  {
    slug: 'great-yarmouth',
    name: 'Great Yarmouth',
    region: 'Norfolk',
    headline_keyword: 'Great Yarmouth',
    h1_phrase: 'Great Yarmouth',
    primary: false,
    neighbourhoods: [
      'Great Yarmouth', 'Gorleston-on-Sea', 'Caister-on-Sea', 'Hopton',
      'Bradwell', 'Belton', 'Burgh Castle',
    ],
    nearby_pages: ['norwich', 'norfolk', 'east-anglia', 'kings-lynn'],
    blurb: 'AI marketing for Great Yarmouth businesses — hotels, B&Bs, trades, restaurants.',
  },
  {
    slug: 'wymondham',
    name: 'Wymondham',
    region: 'Norfolk',
    headline_keyword: 'Wymondham',
    h1_phrase: 'Wymondham',
    primary: false,
    neighbourhoods: [
      'Wymondham', 'Spooner Row', 'Hethersett', 'Mulbarton', 'Hethel', 'Attleborough',
    ],
    nearby_pages: ['norwich', 'norfolk', 'east-anglia'],
    blurb: 'Web design and growth systems for Wymondham and South Norfolk businesses.',
  },
  {
    slug: 'dereham',
    name: 'Dereham',
    region: 'Norfolk',
    headline_keyword: 'Dereham',
    h1_phrase: 'Dereham',
    primary: false,
    neighbourhoods: [
      'Dereham', 'East Dereham', 'Toftwood', 'Yaxham', 'Mattishall', 'Swanton Morley',
    ],
    nearby_pages: ['norwich', 'norfolk', 'east-anglia'],
    blurb: 'Local marketing systems for Dereham businesses across mid-Norfolk.',
  },
  {
    slug: 'cromer',
    name: 'Cromer',
    region: 'Norfolk',
    headline_keyword: 'Cromer',
    h1_phrase: 'Cromer',
    primary: false,
    neighbourhoods: [
      'Cromer', 'Sheringham', 'Overstrand', 'West Runton', 'East Runton', 'Holt',
    ],
    nearby_pages: ['norwich', 'norfolk', 'east-anglia'],
    blurb: 'AI marketing for hotels, B&Bs and seaside businesses across the North Norfolk coast.',
  },
  {
    slug: 'thetford',
    name: 'Thetford',
    region: 'Norfolk',
    headline_keyword: 'Thetford',
    h1_phrase: 'Thetford',
    primary: false,
    neighbourhoods: [
      'Thetford', 'Brandon', 'Mundford', 'Watton', 'East Harling',
    ],
    nearby_pages: ['norwich', 'norfolk', 'east-anglia'],
    blurb: 'Web design and growth systems for Thetford and Breckland businesses.',
  },
  // ============================================================
  // UK-WIDE STRATEGIC CITIES (added for national SEO coverage)
  // ============================================================
  {
    slug: 'london',
    name: 'London',
    region: 'Greater London',
    headline_keyword: 'London',
    h1_phrase: 'London',
    primary: false,
    neighbourhoods: [
      'Central London', 'Shoreditch', 'Camden', 'Islington', 'Hackney', 'Soho',
      'Canary Wharf', 'Greenwich', 'Hammersmith', 'Chelsea', 'Clapham', 'Brixton',
    ],
    nearby_pages: ['cambridge', 'ipswich', 'norwich', 'bristol'],
    blurb: 'AI marketing for London businesses — agencies, trades, hospitality, professional services, fintech.',
  },
  {
    slug: 'manchester',
    name: 'Manchester',
    region: 'Greater Manchester',
    headline_keyword: 'Manchester',
    h1_phrase: 'Manchester',
    primary: false,
    neighbourhoods: [
      'Manchester City Centre', 'Salford', 'MediaCityUK', 'Didsbury', 'Chorlton',
      'Trafford', 'Stockport', 'Altrincham', 'Bolton', 'Rochdale',
    ],
    nearby_pages: ['leeds', 'birmingham', 'liverpool', 'london'],
    blurb: 'AI marketing and growth systems for Manchester businesses across the North West.',
  },
  {
    slug: 'birmingham',
    name: 'Birmingham',
    region: 'West Midlands',
    headline_keyword: 'Birmingham',
    h1_phrase: 'Birmingham',
    primary: false,
    neighbourhoods: [
      'Birmingham City Centre', 'Digbeth', 'Jewellery Quarter', 'Edgbaston',
      'Solihull', 'Sutton Coldfield', 'Coventry', 'Wolverhampton', 'Walsall',
    ],
    nearby_pages: ['manchester', 'leeds', 'bristol', 'london'],
    blurb: 'AI websites, automation and growth systems for Birmingham and Midlands businesses.',
  },
  {
    slug: 'leeds',
    name: 'Leeds',
    region: 'West Yorkshire',
    headline_keyword: 'Leeds',
    h1_phrase: 'Leeds',
    primary: false,
    neighbourhoods: [
      'Leeds City Centre', 'Headingley', 'Chapel Allerton', 'Roundhay',
      'Bradford', 'Wakefield', 'Harrogate', 'Otley', 'Pudsey',
    ],
    nearby_pages: ['manchester', 'edinburgh', 'birmingham', 'london'],
    blurb: 'AI marketing for Leeds and Yorkshire businesses — trades, recruitment, hospitality, professional services.',
  },
  {
    slug: 'bristol',
    name: 'Bristol',
    region: 'South West',
    headline_keyword: 'Bristol',
    h1_phrase: 'Bristol',
    primary: false,
    neighbourhoods: [
      'Bristol City Centre', 'Clifton', 'Redland', 'Bedminster', 'Stokes Croft',
      'Bath', 'Weston-super-Mare', 'Filton', 'Kingswood',
    ],
    nearby_pages: ['london', 'birmingham', 'cambridge', 'manchester'],
    blurb: 'AI marketing and growth systems for Bristol and South West businesses.',
  },
  {
    slug: 'cambridge',
    name: 'Cambridge',
    region: 'Cambridgeshire',
    headline_keyword: 'Cambridge',
    h1_phrase: 'Cambridge',
    primary: false,
    neighbourhoods: [
      'Cambridge City Centre', 'Cherry Hinton', 'Trumpington', 'Histon',
      'Ely', 'Newmarket', 'Huntingdon', 'St Neots', 'Peterborough',
    ],
    nearby_pages: ['norwich', 'ipswich', 'london', 'east-anglia'],
    blurb: 'AI marketing for Cambridge tech, biotech, and professional service businesses.',
  },
  {
    slug: 'ipswich',
    name: 'Ipswich',
    region: 'Suffolk',
    headline_keyword: 'Ipswich',
    h1_phrase: 'Ipswich',
    primary: false,
    neighbourhoods: [
      'Ipswich Town Centre', 'Felixstowe', 'Bury St Edmunds', 'Sudbury',
      'Stowmarket', 'Lowestoft', 'Woodbridge', 'Hadleigh',
    ],
    nearby_pages: ['norwich', 'cambridge', 'east-anglia', 'london'],
    blurb: 'AI marketing for Ipswich and Suffolk businesses — trades, ports, hospitality, services.',
  },
  {
    slug: 'edinburgh',
    name: 'Edinburgh',
    region: 'Scotland',
    headline_keyword: 'Edinburgh',
    h1_phrase: 'Edinburgh',
    primary: false,
    neighbourhoods: [
      'Edinburgh City Centre', 'Old Town', 'New Town', 'Leith', 'Stockbridge',
      'Glasgow', 'Stirling', 'Falkirk', 'Livingston', 'Dunfermline',
    ],
    nearby_pages: ['leeds', 'manchester', 'london'],
    blurb: 'AI marketing for Edinburgh and Scottish businesses — tourism, professional services, trades, hospitality.',
  },
];

export const getLocalArea = (slug) => LOCAL_AREAS.find((a) => a.slug === slug) || null;
